import React, { Component } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';


import '../stylesheets/daterangepicker.css';

export  class DateRange extends Component {
    
    constructor(props){
        super(props);

        this.state = {
            range: ''
        }
    }

    onApply = (e) => {
        this.props.onChange(e);

        const range = getDateRange(e.target.value);

        this.setState({
            range: e.target.value,
            ...range
        });
    }
    
    render() {
        const { inputClass='' } = this.props;
        const { range, start_date, end_date } = this.state;

        return (
            <DateRangePicker 
                startDate={ start_date } 
                endDate={ end_date }
                locale={{ format: 'YYYY-MM-DD' }}
                onApply={ (e)=>{ this.onApply(e) } }>

                <input 
                    { ...this.props }
                    type="text" 
                    className={ "form-control date-picker-control " + inputClass }
                    placeholder="Select date range"
                    defaultValue={ range } />

            </DateRangePicker>
        )
    }
}

export const getDateRange = (value) => {
    let dateObj = value.split(" - ");

    return {
        start_date: dateObj[0],
        end_date: dateObj[1]
    };
}



// WEBPACK FOOTER //
// ./src/components/DateRange.jsx